import gql from 'graphql-tag';

export const CREATE_APPLICANT = gql`
  mutation (
    $email: String!
    $surname: String!
    $givenName: String!
    $chineseName: String
    $gender: GENDER!
    $PIDeclaration: Boolean!
    $addressCountryRegion: String!
    $addressLine1: String!
    $addressLine2: String
    $addressLine3: String
    $dateOfBirth: DateTime!
    $identityType: String!
    $identityDocumentType: IDENTITY_DOCUMENT_TYPE
    $identityDocumentNumber: String!
    $isLocal: Boolean
    $needStudentVisa: Boolean
    $mobileNumber: String!
    $telephoneNumber: String
    $nationality: String!
    $province: String
    $disabilitySpecial: DisabilitySpecialInput
    $user: CreateUserInputV2
  ) {
    createApplicant(
      user: $user
      input: {
        email: $email
        name: {
          surname: $surname
          givenName: $givenName
          chineseName: $chineseName
        }
        gender: $gender
        PIDeclaration: $PIDeclaration
        addressCountryRegion: $addressCountryRegion
        addressLine1: $addressLine1
        addressLine2: $addressLine2
        addressLine3: $addressLine3
        dateOfBirth: $dateOfBirth
        identity: {
          identityType: $identityType
          identityDocumentType: $identityDocumentType
          identityDocumentNumber: $identityDocumentNumber
          isLocal: $isLocal
          needStudentVisa: $needStudentVisa
        }
        mobileNumber: $mobileNumber
        nationality: $nationality
        telephoneNumber: $telephoneNumber
        province: $province
        disabilitySpecial: $disabilitySpecial
      }
    ) {
      _id
    }
  }
`;
